const LEVEL_SEPARATOR = ' > '

type Crumb = { label: string; url: string }

function clean(name: string | undefined): string {
  // A '>' inside a name would read as one more level.
  return (name ?? '').replaceAll('>', '-').replace(/\s+/g, ' ').trim()
}

export function pageCategoryPath(
  breadcrumb: Crumb[] | undefined,
  pageTitle: string | undefined,
  id: string | undefined,
): string {
  // The first crumb is the home page.
  const levels = (breadcrumb ?? [])
    .slice(1)
    .map((crumb) => clean(crumb.label))
    .filter(Boolean)

  if (levels.length > 0) return levels.join(LEVEL_SEPARATOR)

  const title = clean(pageTitle)
  if (title) return title

  return id ?? ''
}
